var map = {
	"./InvestProjects.svg": 3165,
	"./InvestProjects_dark.svg": 7217,
	"./barbourabi.svg": 1728,
	"./baublatt.svg": 1568,
	"./buildingRadar.svg": 4093,
	"./byggefaktadk.svg": 2349,
	"./contactb.svg": 6653,
	"./dtad.svg": 9372,
	"./ibau.svg": 824,
	"Images/DataSourceIcons/InvestProjects.svg": 3165,
	"Images/DataSourceIcons/InvestProjects_dark.svg": 7217,
	"Images/DataSourceIcons/barbourabi.svg": 1728,
	"Images/DataSourceIcons/baublatt.svg": 1568,
	"Images/DataSourceIcons/buildingRadar.svg": 4093,
	"Images/DataSourceIcons/byggefaktadk.svg": 2349,
	"Images/DataSourceIcons/contactb.svg": 6653,
	"Images/DataSourceIcons/dtad.svg": 9372,
	"Images/DataSourceIcons/ibau.svg": 824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5019;